import React, { useState, useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import axios from 'axios';
import Header from './Header';
import Footer from './Footer';
import { API_KEY, API_ENDPOINTS, LANGUAGE, IMAGE_BASE_URL } from '../config/api';
import './Search.css';

const SearchResultPage = () => {
    const location = useLocation();
    const [searchResults, setSearchResults] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filterType, setFilterType] = useState('all'); // all, movie, tv

    const query = new URLSearchParams(location.search).get('query');

    useEffect(() => {
        if (query) {
            searchMovies(query);
        }
    }, [query, filterType]);

    const searchMovies = async (searchQuery) => {
        try {
            setLoading(true);
            const response = await axios.get(
                `${API_ENDPOINTS.SEARCH}?api_key=${API_KEY}&language=${LANGUAGE}&query=${encodeURIComponent(searchQuery)}&include_adult=false`
            );
            let results = response.data.results;
            
            if (filterType === 'movie') {
                results = results.filter(item => item.media_type === 'movie');
            } else if (filterType === 'tv') {
                results = results.filter(item => item.media_type === 'tv');
            }
            
            setSearchResults(results);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const getDetailPath = (item) => {
        if (item.media_type === 'tv') {
            return `/tv/id/${item.id}`;
        }
        return `/film/id/${item.id}`;
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'Дата неизвестна';
        const date = new Date(dateString);
        return date.getFullYear();
    };

    return (
        <div className="search-page">
            <Header />
            <div className="container-xl mt-4">
                <div className="search-header">
                    <h1 className="search-title">
                        Результаты поиска {query && `"${query}"`}
                    </h1>
                    <div className="search-filters">
                        <button
                            className={`filter-btn ${filterType === 'all' ? 'active' : ''}`}
                            onClick={() => setFilterType('all')}
                        >
                            Все
                        </button>
                        <button
                            className={`filter-btn ${filterType === 'movie' ? 'active' : ''}`}
                            onClick={() => setFilterType('movie')}
                        >
                            Фильмы
                        </button>
                        <button
                            className={`filter-btn ${filterType === 'tv' ? 'active' : ''}`}
                            onClick={() => setFilterType('tv')}
                        >
                            Сериалы
                        </button>
                    </div>
                </div>

                {loading ? (
                    <div className="loading-container">
                        <div className="spinner"></div>
                        <p>Поиск...</p>
                    </div>
                ) : searchResults.length === 0 ? (
                    <div className="no-results">
                        <p>Ничего не найдено по запросу "{query}"</p>
                    </div>
                ) : (
                    <div className="search-results-grid">
                        {searchResults.map((result) => (
                            <Link
                                key={`${result.id}-${result.media_type}`}
                                to={getDetailPath(result)}
                                className="search-result-card"
                            >
                                <div className="result-poster-container">
                                    <img
                                        src={
                                            result.poster_path
                                                ? `${IMAGE_BASE_URL}/w342${result.poster_path}`
                                                : '/images/placeholder.jpg'
                                        }
                                        alt={result.title || result.name}
                                        className="result-poster"
                                    />
                                    <div className="result-type-badge">
                                        {result.media_type === 'movie' ? '🎬 Фильм' : '📺 Сериал'}
                                    </div>
                                </div>
                                <div className="result-info">
                                    <h3 className="result-title">
                                        {result.title || result.name}
                                    </h3>
                                    <div className="result-meta">
                                        <span className="result-year">
                                            {formatDate(result.release_date || result.first_air_date)}
                                        </span>
                                        {result.vote_average > 0 && (
                                            <span className="result-rating">
                                                ⭐ {result.vote_average.toFixed(1)}
                                            </span>
                                        )}
                                    </div>
                                    {result.overview && (
                                        <p className="result-overview">
                                            {result.overview.length > 150
                                                ? `${result.overview.substring(0, 150)}...`
                                                : result.overview}
                                        </p>
                                    )}
                                </div>
                            </Link>
                        ))}
                    </div>
                )}
            </div>
            <Footer />
        </div>
    );
};

export default SearchResultPage;
